import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList } from "vue";
const _hoisted_1 = { class: "min-h-screen bg-gray-50 font-roboto" };
const _hoisted_2 = { class: "max-w-7xl mx-auto p-4 lg:p-6" };
const _hoisted_3 = {
    key: 0,
    class: "mb-6 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900",
    role: "status"
};
const _hoisted_4 = {
    key: 1,
    class: "text-center py-12"
};
const _hoisted_5 = { class: "bg-red-50 border border-red-200 rounded-lg p-6 text-center max-w-md mx-auto" };
const _hoisted_6 = {
    class: "text-red-600 mb-4",
    style: { "color": "#dc2626 !important" }
};
const _hoisted_7 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8" };
const _hoisted_8 = { class: "lg:col-span-2 space-y-6" };
const _hoisted_9 = { class: "bg-white rounded-lg shadow-md p-4 lg:p-6" };
const _hoisted_10 = { class: "flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4 lg:mb-6" };
const _hoisted_11 = {
    class: "text-lg lg:text-xl font-semibold text-gray-800 mb-1",
    style: { "color": "#1f2937 !important" }
};
const _hoisted_12 = {
    class: "text-sm lg:text-base text-gray-600",
    style: { "color": "#4b5563 !important" }
};
const _hoisted_13 = { class: "mt-3 sm:mt-0" };
const _hoisted_14 = { class: "bg-white rounded-lg shadow-md p-4 lg:p-6" };
const _hoisted_15 = {
    class: "text-lg font-semibold text-gray-800 mb-4",
    style: { "color": "#1f2937 !important" }
};
const _hoisted_16 = { class: "space-y-4" };
const _hoisted_17 = { class: "flex items-center p-3 bg-gray-50 rounded-lg" };
const _hoisted_18 = { class: "mr-3" };
const _hoisted_19 = {
    key: 0,
    class: "w-6 h-6 text-blue-600",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
};
const _hoisted_20 = {
    key: 1,
    class: "w-6 h-6 text-green-600",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
};
const _hoisted_21 = { class: "flex-1" };
const _hoisted_22 = {
    class: "font-medium",
    style: { "color": "#111827 !important" }
};
const _hoisted_23 = {
    class: "text-sm text-gray-600",
    style: { "color": "#4b5563 !important" }
};
const _hoisted_24 = {
    key: 0,
    class: "p-4 bg-blue-50 rounded-lg border border-blue-200"
};
const _hoisted_25 = {
    class: "text-blue-700",
    style: { "color": "#1d4ed8 !important" }
};
const _hoisted_26 = {
    key: 0,
    class: "text-sm text-blue-600 mt-2",
    style: { "color": "#2563eb !important" }
};
const _hoisted_27 = { class: "bg-white rounded-lg shadow-md p-4 lg:p-6" };
const _hoisted_28 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-4" };
const _hoisted_29 = { class: "p-3 bg-gray-50 rounded-lg" };
const _hoisted_30 = {
    class: "font-medium",
    style: { "color": "#111827 !important" }
};
const _hoisted_31 = { class: "p-3 bg-gray-50 rounded-lg" };
const _hoisted_32 = {
    class: "font-medium text-sm",
    style: { "color": "#111827 !important" }
};
const _hoisted_33 = {
    key: 0,
    class: "p-3 bg-gray-50 rounded-lg"
};
const _hoisted_34 = {
    class: "font-medium",
    style: { "color": "#111827 !important" }
};
const _hoisted_35 = { class: "p-3 bg-gray-50 rounded-lg" };
const _hoisted_36 = {
    class: "font-medium",
    style: { "color": "#111827 !important" }
};
const _hoisted_37 = { class: "space-y-6" };
const _hoisted_38 = { class: "bg-white rounded-lg shadow-md p-4 lg:p-6" };
const _hoisted_39 = { class: "space-y-3 mb-6" };
const _hoisted_40 = { class: "flex justify-between items-start" };
const _hoisted_41 = { class: "flex-1 pr-3" };
const _hoisted_42 = {
    class: "font-medium text-sm lg:text-base",
    style: { "color": "#111827 !important" }
};
const _hoisted_43 = {
    class: "text-xs lg:text-sm text-gray-600 mt-1",
    style: { "color": "#4b5563 !important" }
};
const _hoisted_44 = {
    key: 0,
    class: "mt-2 text-xs text-gray-600 space-y-2 pl-3 border-l-2 border-gray-300"
};
const _hoisted_45 = { class: "text-gray-800" };
const _hoisted_46 = { class: "font-medium" };
const _hoisted_47 = {
    key: 0,
    class: "text-gray-500"
};
const _hoisted_48 = {
    key: 0,
    class: "mt-1 flex flex-wrap gap-1"
};
const _hoisted_49 = {
    key: 0,
    class: "ml-1 font-medium"
};
const _hoisted_50 = {
    key: 1,
    class: "mt-1 text-gray-600 italic"
};
const _hoisted_51 = {
    key: 1,
    class: "mt-2"
};
const _hoisted_52 = { class: "flex flex-wrap gap-1" };
const _hoisted_53 = {
    key: 2,
    class: "mt-2"
};
const _hoisted_54 = { class: "flex flex-wrap gap-1" };
const _hoisted_55 = {
    key: 3,
    class: "mt-2"
};
const _hoisted_56 = { class: "flex flex-wrap gap-1" };
const _hoisted_57 = {
    key: 4,
    class: "mt-1"
};
const _hoisted_58 = {
    class: "text-xs text-blue-600 italic",
    style: { "color": "#2563eb !important" }
};
const _hoisted_59 = { class: "text-right" };
const _hoisted_60 = {
    class: "font-semibold text-sm lg:text-base",
    style: { "color": "#111827 !important" }
};
const _hoisted_61 = { class: "border-t border-gray-200 pt-4" };
const _hoisted_62 = { class: "space-y-2" };
const _hoisted_63 = { class: "flex justify-between text-sm" };
const _hoisted_64 = { style: { "color": "#4b5563 !important" } };
const _hoisted_65 = {
    key: 0,
    class: "bg-green-50 border border-green-200 rounded-lg p-3 -mx-1"
};
const _hoisted_66 = { class: "flex justify-between items-start" };
const _hoisted_67 = { class: "flex-1" };
const _hoisted_68 = {
    key: 0,
    class: "space-y-1"
};
const _hoisted_69 = { class: "font-mono bg-green-100 px-2 py-0.5 rounded" };
const _hoisted_70 = { class: "ml-1" };
const _hoisted_71 = { class: "ml-1 text-green-600" };
const _hoisted_72 = { class: "text-right" };
const _hoisted_73 = {
    class: "font-semibold text-green-700",
    style: { "color": "#047857 !important" }
};
const _hoisted_74 = {
    key: 1,
    class: "flex justify-between text-sm font-medium pt-1 border-t border-gray-100"
};
const _hoisted_75 = { style: { "color": "#1f2937 !important" } };
const _hoisted_76 = {
    key: 2,
    class: "flex justify-between text-sm"
};
const _hoisted_77 = { style: { "color": "#4b5563 !important" } };
const _hoisted_78 = {
    key: 3,
    class: "flex justify-between text-sm"
};
const _hoisted_79 = { style: { "color": "#4b5563 !important" } };
const _hoisted_80 = {
    key: 4,
    class: "flex justify-between text-sm"
};
const _hoisted_81 = {
    key: 5,
    class: "flex justify-between text-sm"
};
const _hoisted_82 = { style: { "color": "#4b5563 !important" } };
const _hoisted_83 = { class: "flex justify-between font-bold text-lg pt-3 mt-3 border-t border-gray-200" };
const _hoisted_84 = { style: { "color": "#dc2626 !important" } };
const _hoisted_85 = { class: "flex justify-between items-center pt-3 mt-3 border-t border-gray-200" };
const _hoisted_86 = {
    key: 0,
    class: "w-4 h-4 mr-1",
    fill: "currentColor",
    viewBox: "0 0 20 20"
};
const _hoisted_87 = {
    key: 6,
    class: "flex justify-between text-sm"
};
const _hoisted_88 = { style: { "color": "#4b5563 !important" } };
const _hoisted_89 = { class: "bg-white rounded-lg shadow-md p-4 lg:p-6" };
const _hoisted_90 = { class: "space-y-3" };
const _hoisted_91 = ["disabled"];
const _hoisted_92 = ["disabled"];
import { ref, computed, onMounted, onUnmounted, watch } from "vue";
import { useRoute } from 'vue-router'; // ✅ Import useRoute for fallback
import OrderProgressTimeline from '../components/order/OrderProgressTimeline.vue';
import { useOrders } from '../composables/useOrders';
import { isDemoHost } from '../composables/useSiteConfig';
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderStatusPage',
    props: {
        orderNumber: {}
    },
    setup(__props) {
        const props = __props;
        const route = useRoute(); // ✅ Fallback wenn keine Props
        // ✅ Computed: Get orderNumber from props OR route params
        const currentOrderNumber = computed(() => {
            // Priority 1: Props from router (wenn props: true gesetzt ist)
            if (props.orderNumber) {
                console.log('📦 [OrderStatus] Using orderNumber from props:', props.orderNumber);
                return props.orderNumber;
            }
            // Priority 2: Route params (fallback für direkte URL-Aufrufe)
            const routeParam = route.params.orderNumber;
            if (routeParam) {
                console.log('📦 [OrderStatus] Using orderNumber from route.params:', routeParam);
                return routeParam;
            }
            console.warn('⚠️ [OrderStatus] No orderNumber found in props or route params');
            return null;
        });
        // ✅ Use useOrders composable instead of injecting apiClient
        const { getOrderByNumber, cancelOrder: cancelOrderComposable } = useOrders();
        // Create API methods with proper return types
        const fetchOrderByNumber = async (orderNumber) => {
            return await getOrderByNumber(orderNumber);
        };
        const cancelOrderApi = async (orderId, reason) => {
            const success = await cancelOrderComposable(orderId, reason);
            return success ? { id: orderId, status: "cancelled" } : null;
        };
        // State
        const order = ref(null);
        const loading = ref(true);
        const error = ref(null);
        const cancelling = ref(false);
        const isDemoPreview = computed(() => isDemoHost());
        // Auto-refresh interval
        let refreshInterval = null;
        // Lifecycle
        onMounted(async () => {
            await loadOrder();
            startAutoRefresh();
        });
        onUnmounted(() => {
            stopAutoRefresh();
        });
        // ✅ Watch for orderNumber changes (if user navigates to different order)
        watch(() => currentOrderNumber.value, async (newOrderNumber) => {
            if (newOrderNumber) {
                console.log('📦 [OrderStatus] OrderNumber changed, reloading:', newOrderNumber);
                await loadOrder();
            }
        });
        // Methods
        async function loadOrder() {
            const orderNum = currentOrderNumber.value;
            if (!orderNum) {
                error.value = "Keine Bestellnummer angegeben";
                loading.value = false;
                console.error('❌ [OrderStatus] No order number provided');
                return;
            }
            console.log('📦 [OrderStatus] Loading order:', orderNum);
            try {
                loading.value = true;
                error.value = null;
                const foundOrder = await fetchOrderByNumber(orderNum);
                if (foundOrder) {
                    order.value = foundOrder;
                    console.log('✅ [OrderStatus] Order loaded:', foundOrder.orderNumber);
                }
                else {
                    error.value = `Bestellung #${orderNum} wurde nicht gefunden`;
                    console.error('❌ [OrderStatus] Order not found:', orderNum);
                }
            }
            catch (err) {
                console.error("Error loading order:", err);
                error.value = err.message || "Fehler beim Laden der Bestellung";
            }
            finally {
                loading.value = false;
            }
        }
        async function refreshStatus() {
            if (!order.value)
                return;
            try {
                const refreshedOrder = await fetchOrderByNumber(order.value.orderNumber);
                if (refreshedOrder) {
                    order.value = refreshedOrder;
                }
            }
            catch (err) {
                console.error("Error refreshing order:", err);
            }
        }
        function startAutoRefresh() {
            // Refresh every 30 seconds if order is not completed
            refreshInterval = setInterval(async () => {
                if (order.value && !isOrderCompleted.value) {
                    await refreshStatus();
                }
            }, 30000);
        }
        function stopAutoRefresh() {
            if (refreshInterval) {
                clearInterval(refreshInterval);
                refreshInterval = null;
            }
        }
        async function cancelOrder() {
            if (!order.value || !canCancelOrder.value)
                return;
            const confirmed = confirm("Möchtest du diese Bestellung wirklich stornieren?");
            if (!confirmed)
                return;
            try {
                cancelling.value = true;
                const cancelledOrder = await cancelOrderApi(order.value._id, "Storniert vom Kunden");
                if (cancelledOrder) {
                    order.value = cancelledOrder;
                }
            }
            catch (err) {
                console.error("Error cancelling order:", err);
                alert("Fehler beim Stornieren der Bestellung: " + (err.message || "Unbekannter Fehler"));
            }
            finally {
                cancelling.value = false;
            }
        }
        // Computed properties
        const isOrderCompleted = computed(() => {
            return (order.value && ["delivered", "cancelled", "refunded"].includes(order.value.status));
        });
        const canCancelOrder = computed(() => {
            // ✅ Bezahlte Bestellungen können NICHT storniert werden
            if (order.value?.payment?.status === "paid") {
                return false;
            }
            // ✅ Nur pending Orders können storniert werden
            return order.value && order.value.status === "pending";
        });
        // ✅ Calculate original subtotal (before discount) for display
        const originalSubtotalCent = computed(() => {
            if (!order.value)
                return 0;
            return order.value.itemsTotalCent || 0;
        });
        // ✅ Calculate subtotal after discount for display
        const discountedSubtotalCent = computed(() => {
            if (!order.value)
                return 0;
            return (order.value.itemsTotalCent || 0) - (order.value.discountAmountCent || 0);
        });
        // Helper functions
        function formatPrice(priceCent) {
            if (priceCent === undefined || priceCent === null || isNaN(priceCent)) {
                console.warn("formatPrice called with invalid value:", priceCent);
                return "0,00€";
            }
            const priceEuro = priceCent / 100;
            return `${priceEuro.toFixed(2).replace(".", ",")}€`;
        }
        function formatOrderDate(dateString) {
            const date = new Date(dateString);
            return date.toLocaleString("de-DE", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            });
        }
        function getStatusText(status, orderType) {
            const isDelivery = orderType === "delivery";
            const statusTexts = {
                pending: "Warten auf Bestätigung",
                confirmed: "Bestätigt",
                preparing: "Wird zubereitet",
                ready: isDelivery ? "Auf dem Weg" : "Bereit zur Abholung",
                out_for_delivery: "Auf dem Weg",
                delivered: "Zugestellt",
                cancelled: "Storniert",
                refunded: "Erstattet",
            };
            return statusTexts[status] || status;
        }
        function getStatusBadgeClass(status) {
            const classes = {
                pending: "bg-yellow-100 text-yellow-800",
                confirmed: "bg-blue-100 text-blue-800",
                preparing: "bg-purple-100 text-purple-800",
                ready: "bg-green-100 text-green-800",
                out_for_delivery: "bg-indigo-100 text-indigo-800",
                delivered: "bg-green-100 text-green-800",
                cancelled: "bg-red-100 text-red-800",
                refunded: "bg-gray-100 text-gray-800",
            };
            return classes[status] || "bg-gray-100 text-gray-800";
        }
        function getPaymentMethodText(method) {
            const methods = {
                cash: "Barzahlung vor Ort",
                card: "Kartenzahlung",
                paypal: "PayPal",
                bank_transfer: "Überweisung",
                crypto: "Kryptowährung",
            };
            return methods[method] || method;
        }
        function getPaymentStatusText(status) {
            const statuses = {
                pending: "Ausstehend",
                paid: "Bezahlt",
                failed: "Fehlgeschlagen",
                refunded: "Erstattet",
            };
            return statuses[status || "pending"] || "Unbekannt";
        }
        function getPaymentStatusClass(status) {
            const classes = {
                pending: "bg-yellow-100 text-yellow-800",
                paid: "bg-green-100 text-green-800",
                failed: "bg-red-100 text-red-800",
                refunded: "bg-gray-100 text-gray-800",
            };
            return classes[status || "pending"] || "bg-gray-100 text-gray-800";
        }
        function resolveProjectTimezone() {
            if (!order.value) {
                return "Europe/Berlin";
            }
            return (order.value.pricingBreakdown?.delivery?.timezone ||
                order.value.pricingBreakdown?.delivery?.timeZone ||
                order.value.projectTimezone ||
                "Europe/Berlin");
        }
        function formatTimeInTimezone(value) {
            if (!value) {
                return "";
            }
            const timezone = resolveProjectTimezone();
            const isoValue = value instanceof Date ? value.toISOString() : value;
            try {
                const date = new Date(isoValue);
                if (Number.isNaN(date.getTime())) {
                    return "";
                }
                return new Intl.DateTimeFormat("de-DE", {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: false,
                    timeZone: timezone,
                }).format(date);
            }
            catch (error) {
                const fallbackDate = new Date(isoValue);
                if (Number.isNaN(fallbackDate.getTime())) {
                    return "";
                }
                return fallbackDate.toLocaleTimeString("de-DE", {
                    hour: "2-digit",
                    minute: "2-digit",
                });
            }
        }
        function getEstimatedTimeDisplay() {
            if (!order.value)
                return "";
            const isDelivery = order.value.orderType === "delivery";
            if (isDelivery && ["ready", "out_for_delivery"].includes(order.value.status)) {
                const driverCountdown = getDriverEtaDisplay();
                if (driverCountdown) {
                    return driverCountdown;
                }
            }
            const plannedTimestamp = order.value.requestedDeliveryTime || order.value.deliveryInfo?.requestedDeliveryTime;
            const isPlannedOrder = Boolean(order.value.isPlanned || plannedTimestamp);
            if (plannedTimestamp) {
                const plannedLabel = formatTimeInTimezone(plannedTimestamp);
                if (plannedLabel) {
                    return `${plannedLabel} Uhr`;
                }
            }
            if (isPlannedOrder && order.value.estimatedTime) {
                const estimatedLabel = formatTimeInTimezone(order.value.estimatedTime);
                if (estimatedLabel) {
                    return `${estimatedLabel} Uhr`;
                }
            }
            // ✅ STRATEGY 1: Use selectedTime.display when not planned
            const selectedTime = order.value.pricingBreakdown?.delivery?.selectedTime;
            if (!isPlannedOrder && isDelivery && selectedTime?.delivery?.display) {
                return selectedTime.delivery.display;
            }
            if (!isPlannedOrder && !isDelivery && selectedTime?.pickup?.display) {
                return selectedTime.pickup.display;
            }
            // ✅ STRATEGY 2: Use deliveryTime/pickupTime min-max ranges
            const deliveryTime = order.value.pricingBreakdown?.delivery?.deliveryTime;
            const pickupTime = order.value.pricingBreakdown?.delivery?.pickupTime;
            if (!isPlannedOrder && isDelivery && deliveryTime?.min && deliveryTime?.max) {
                return `in ${deliveryTime.min}-${deliveryTime.max} Minuten`;
            }
            if (!isPlannedOrder && !isDelivery && pickupTime?.min && pickupTime?.max) {
                return `in ${pickupTime.min}-${pickupTime.max} Minuten`;
            }
            // ✅ STRATEGY 3: Calculate from estimatedTime (fallback)
            if (order.value.estimatedTime) {
                const estimatedDate = new Date(order.value.estimatedTime);
                if (!Number.isNaN(estimatedDate.getTime())) {
                    if (order.value.estimatedLatestTime) {
                        const latestDate = new Date(order.value.estimatedLatestTime);
                        const earliestStr = formatTimeInTimezone(estimatedDate);
                        const latestStr = formatTimeInTimezone(latestDate);
                        if (earliestStr && latestStr) {
                            return `zwischen ${earliestStr} - ${latestStr} Uhr`;
                        }
                    }
                    const diffMinutes = Math.ceil((estimatedDate.getTime() - Date.now()) / (1000 * 60));
                    if (diffMinutes > 0 && diffMinutes < 180 && !isPlannedOrder) {
                        return `in ca. ${diffMinutes} Minuten`;
                    }
                    const formattedEstimate = formatTimeInTimezone(estimatedDate);
                    if (formattedEstimate) {
                        return `${formattedEstimate} Uhr`;
                    }
                }
            }
            // ✅ STRATEGY 4: Static fallback
            return isDelivery ? "in ca. 30-60 Minuten" : "in ca. 15-20 Minuten";
        }
        function getDriverEtaDisplay() {
            const expectedArrival = order.value?.deliveryRoute?.expectedArrivalAt;
            const durationSeconds = order.value?.deliveryRoute?.durationSeconds;
            const startedAt = order.value?.deliveryRoute?.startedAt;
            let arrivalDate = null;
            if (expectedArrival) {
                arrivalDate = new Date(expectedArrival);
            }
            else if (durationSeconds && startedAt) {
                arrivalDate = new Date(new Date(startedAt).getTime() + durationSeconds * 1000);
            }
            if (!arrivalDate || Number.isNaN(arrivalDate.getTime())) {
                return "";
            }
            const remainingMinutes = Math.ceil((arrivalDate.getTime() - Date.now()) / (1000 * 60));
            if (remainingMinutes < 1) {
                return "Es dürfte gleich an deiner Tür klingeln!";
            }
            return `Der Fahrer ist voraussichtlich in ca. ${remainingMinutes} Minuten bei dir`;
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createCommentVNode(" Header "),
                    _cache[31] || (_cache[31] = _createElementVNode("div", { class: "text-center mb-6 lg:mb-8" }, [
                        _createElementVNode("h1", {
                            class: "text-2xl lg:text-3xl font-bold text-gray-800 mb-2",
                            style: { "color": "#1f2937 !important" }
                        }, " Bestellstatus "),
                        _createElementVNode("p", {
                            class: "text-gray-600",
                            style: { "color": "#4b5563 !important" }
                        }, " Verfolge den Status deiner Bestellung in Echtzeit ")
                    ], -1 /* CACHED */)),
                    (isDemoPreview.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[0] || (_cache[0] = [
                                _createElementVNode("p", { class: "font-semibold" }, "Demo-Modus", -1 /* CACHED */),
                                _createElementVNode("p", { class: "mt-1" }, " Dies ist eine Demo-Bestellung. Die Bestellung wird nicht tatsächlich verarbeitet — der Status wechselt nur zur Veranschaulichung automatisch weiter. ", -1 /* CACHED */)
                            ]))]))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" Loading State "),
                    (loading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[1] || (_cache[1] = [
                                _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4" }, null, -1 /* CACHED */),
                                _createElementVNode("p", {
                                    class: "text-gray-600",
                                    style: { "color": "#4b5563 !important" }
                                }, " Bestelldaten werden geladen... ", -1 /* CACHED */)
                            ]))]))
                        : (error.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createCommentVNode(" Error State "),
                                _createElementVNode("div", _hoisted_5, [
                                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-red-600 mb-4" }, [
                                        _createElementVNode("svg", {
                                            class: "w-12 h-12 mx-auto mb-2",
                                            fill: "none",
                                            stroke: "currentColor",
                                            viewBox: "0 0 24 24"
                                        }, [
                                            _createElementVNode("path", {
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                                "stroke-width": "2",
                                                d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.232 16.5c-.77.833.192 2.5 1.732 2.5z"
                                            })
                                        ])
                                    ], -1 /* CACHED */)),
                                    _cache[4] || (_cache[4] = _createElementVNode("h3", {
                                        class: "text-lg font-semibold text-red-800 mb-2",
                                        style: { "color": "#991b1b !important" }
                                    }, " Bestellung nicht gefunden ", -1 /* CACHED */)),
                                    _createElementVNode("p", _hoisted_6, _toDisplayString(error.value), 1 /* TEXT */),
                                    _createVNode(_component_router_link, {
                                        to: "/speisekarte",
                                        class: "inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                                    }, {
                                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                                _createTextVNode(" Zur Speisekarte ", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    })
                                ])
                            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                            : (order.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                    _createCommentVNode(" Main Content Layout "),
                                    _createElementVNode("div", _hoisted_7, [
                                        _createCommentVNode(" Left Column: Timeline & Order Info (Mobile: First) "),
                                        _createElementVNode("div", _hoisted_8, [
                                            _createCommentVNode(" Order Header Card "),
                                            _createElementVNode("div", _hoisted_9, [
                                                _createElementVNode("div", _hoisted_10, [
                                                    _createElementVNode("div", null, [
                                                        _createElementVNode("h2", _hoisted_11, " Bestellung #" + _toDisplayString(order.value.orderNumber), 1 /* TEXT */),
                                                        _createElementVNode("p", _hoisted_12, _toDisplayString(formatOrderDate(order.value.orderDate)), 1 /* TEXT */)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_13, [
                                                        _createElementVNode("span", {
                                                            class: _normalizeClass([getStatusBadgeClass(order.value.status), "inline-flex items-center px-3 py-1 rounded-full text-sm font-medium"])
                                                        }, _toDisplayString(getStatusText(order.value.status, order.value.orderType)), 3 /* TEXT, CLASS */)
                                                    ])
                                                ]),
                                                _createCommentVNode(" Progress Timeline "),
                                                _createVNode(OrderProgressTimeline, {
                                                    "current-status": order.value.status,
                                                    "order-type": order.value.orderType,
                                                    "status-history": order.value.statusHistory || [],
                                                    "estimated-time": order.value.estimatedPreparationTime
                                                }, null, 8 /* PROPS */, ["current-status", "order-type", "status-history", "estimated-time"])
                                            ]),
                                            _createCommentVNode(" Delivery/Pickup Info "),
                                            _createElementVNode("div", _hoisted_14, [
                                                _createElementVNode("h3", _hoisted_15, _toDisplayString(order.value.orderType === "delivery" ? "Lieferung" : "Abholung"), 1 /* TEXT */),
                                                _createElementVNode("div", _hoisted_16, [
                                                    _createCommentVNode(" Order Type "),
                                                    _createElementVNode("div", _hoisted_17, [
                                                        _createElementVNode("div", _hoisted_18, [
                                                            (order.value.orderType === 'delivery')
                                                                ? (_openBlock(), _createElementBlock("svg", _hoisted_19, [...(_cache[5] || (_cache[5] = [
                                                                        _createElementVNode("path", {
                                                                            "stroke-linecap": "round",
                                                                            "stroke-linejoin": "round",
                                                                            "stroke-width": "2",
                                                                            d: "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                                                                        }, null, -1 /* CACHED */)
                                                                    ]))]))
                                                                : (_openBlock(), _createElementBlock("svg", _hoisted_20, [...(_cache[6] || (_cache[6] = [
                                                                        _createElementVNode("path", {
                                                                            "stroke-linecap": "round",
                                                                            "stroke-linejoin": "round",
                                                                            "stroke-width": "2",
                                                                            d: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                                                                        }, null, -1 /* CACHED */),
                                                                        _createElementVNode("path", {
                                                                            "stroke-linecap": "round",
                                                                            "stroke-linejoin": "round",
                                                                            "stroke-width": "2",
                                                                            d: "M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                                                                        }, null, -1 /* CACHED */)
                                                                    ]))]))
                                                        ]),
                                                        _createElementVNode("div", _hoisted_21, [
                                                            _createElementVNode("p", _hoisted_22, _toDisplayString(order.value.orderType === "delivery" ? "Lieferung" : "Abholung"), 1 /* TEXT */),
                                                            _createElementVNode("p", _hoisted_23, _toDisplayString(getEstimatedTimeDisplay()), 1 /* TEXT */)
                                                        ])
                                                    ]),
                                                    _createCommentVNode(" Delivery Address (if applicable) "),
                                                    (order.value.orderType === 'delivery' && order.value.customer?.address?.street)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                                            _cache[9] || (_cache[9] = _createElementVNode("h4", {
                                                                class: "font-medium text-blue-800 mb-2",
                                                                style: { "color": "#1e40af !important" }
                                                            }, [
                                                                _createElementVNode("i", { class: "fas fa-map-marker-alt mr-2" }),
                                                                _createTextVNode("Lieferadresse ")
                                                            ], -1 /* CACHED */)),
                                                            _createElementVNode("p", _hoisted_25, [
                                                                _createTextVNode(_toDisplayString(order.value.customer.address.street), 1 /* TEXT */),
                                                                _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                                                _createTextVNode(" " + _toDisplayString(order.value.customer.address.postalCode) + " " + _toDisplayString(order.value.customer.address.city), 1 /* TEXT */)
                                                            ]),
                                                            (order.value.customer.address.instructions)
                                                                ? (_openBlock(), _createElementBlock("p", _hoisted_26, [
                                                                    _cache[8] || (_cache[8] = _createElementVNode("i", { class: "fas fa-info-circle mr-1" }, null, -1 /* CACHED */)),
                                                                    _createTextVNode(_toDisplayString(order.value.customer.address.instructions), 1 /* TEXT */)
                                                                ]))
                                                                : _createCommentVNode("v-if", true)
                                                        ]))
                                                        : _createCommentVNode("v-if", true)
                                                ])
                                            ]),
                                            _createCommentVNode(" Customer Info "),
                                            _createElementVNode("div", _hoisted_27, [
                                                _cache[14] || (_cache[14] = _createElementVNode("h3", {
                                                    class: "text-lg font-semibold text-gray-800 mb-4",
                                                    style: { "color": "#1f2937 !important" }
                                                }, " Kundendaten ", -1 /* CACHED */)),
                                                _createElementVNode("div", _hoisted_28, [
                                                    _createElementVNode("div", _hoisted_29, [
                                                        _cache[10] || (_cache[10] = _createElementVNode("p", {
                                                            class: "text-xs uppercase tracking-wide text-gray-500 mb-1",
                                                            style: { "color": "#6b7280 !important" }
                                                        }, " Name ", -1 /* CACHED */)),
                                                        _createElementVNode("p", _hoisted_30, _toDisplayString(order.value.customer.name), 1 /* TEXT */)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_31, [
                                                        _cache[11] || (_cache[11] = _createElementVNode("p", {
                                                            class: "text-xs uppercase tracking-wide text-gray-500 mb-1",
                                                            style: { "color": "#6b7280 !important" }
                                                        }, " E-Mail ", -1 /* CACHED */)),
                                                        _createElementVNode("p", _hoisted_32, _toDisplayString(order.value.customer.email), 1 /* TEXT */)
                                                    ]),
                                                    (order.value.customer.phone)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                                            _cache[12] || (_cache[12] = _createElementVNode("p", {
                                                                class: "text-xs uppercase tracking-wide text-gray-500 mb-1",
                                                                style: { "color": "#6b7280 !important" }
                                                            }, " Telefon ", -1 /* CACHED */)),
                                                            _createElementVNode("p", _hoisted_34, _toDisplayString(order.value.customer.phone), 1 /* TEXT */)
                                                        ]))
                                                        : _createCommentVNode("v-if", true),
                                                    _createElementVNode("div", _hoisted_35, [
                                                        _cache[13] || (_cache[13] = _createElementVNode("p", {
                                                            class: "text-xs uppercase tracking-wide text-gray-500 mb-1",
                                                            style: { "color": "#6b7280 !important" }
                                                        }, " Zahlungsart ", -1 /* CACHED */)),
                                                        _createElementVNode("p", _hoisted_36, _toDisplayString(getPaymentMethodText(order.value.payment.method)), 1 /* TEXT */)
                                                    ])
                                                ])
                                            ])
                                        ]),
                                        _createCommentVNode(" Right Column: Order Details & Actions (Mobile: Second) "),
                                        _createElementVNode("div", _hoisted_37, [
                                            _createCommentVNode(" Order Items "),
                                            _createElementVNode("div", _hoisted_38, [
                                                _cache[27] || (_cache[27] = _createElementVNode("h3", {
                                                    class: "text-lg font-semibold text-gray-800 mb-4",
                                                    style: { "color": "#1f2937 !important" }
                                                }, " Bestelldetails ", -1 /* CACHED */)),
                                                _createElementVNode("div", _hoisted_39, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.value.items, (item) => {
                                                        return (_openBlock(), _createElementBlock("div", {
                                                            key: item._id || item.product,
                                                            class: "p-3 bg-gray-50 rounded-lg border border-gray-200"
                                                        }, [
                                                            _createElementVNode("div", _hoisted_40, [
                                                                _createElementVNode("div", _hoisted_41, [
                                                                    _createElementVNode("h4", _hoisted_42, [
                                                                        (item.itemType === 'menu')
                                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                                _createTextVNode(" Menü: " + _toDisplayString(item.menuName || item.productName), 1 /* TEXT */)
                                                                            ], 64 /* STABLE_FRAGMENT */))
                                                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                                _createTextVNode(_toDisplayString(item.productName), 1 /* TEXT */)
                                                                            ], 64 /* STABLE_FRAGMENT */))
                                                                    ]),
                                                                    _createElementVNode("p", _hoisted_43, [
                                                                        _createTextVNode(_toDisplayString(item.quantity) + "x ", 1 /* TEXT */),
                                                                        (item.itemType !== 'menu')
                                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                                _createTextVNode(_toDisplayString(item.selectedSize ? item.selectedSize.name : ""), 1 /* TEXT */)
                                                                            ], 64 /* STABLE_FRAGMENT */))
                                                                            : _createCommentVNode("v-if", true)
                                                                    ]),
                                                                    (item.itemType === 'menu' && item.menuComponents?.length)
                                                                        ? (_openBlock(), _createElementBlock("ul", _hoisted_44, [
                                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.menuComponents, (comp, cIdx) => {
                                                                                return (_openBlock(), _createElementBlock("li", { key: cIdx }, [
                                                                                    _createElementVNode("div", _hoisted_45, [
                                                                                        _createElementVNode("span", _hoisted_46, _toDisplayString(comp.productName), 1 /* TEXT */),
                                                                                        (comp.selectedSize && comp.selectedSize.name)
                                                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_47, " · " + _toDisplayString(comp.selectedSize.name), 1 /* TEXT */))
                                                                                            : _createCommentVNode("v-if", true)
                                                                                    ]),
                                                                                    (comp.selectedMandatoryIngredients?.length ||
                                                                                        comp.extraIngredients?.length ||
                                                                                        comp.removedIngredients?.length)
                                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comp.selectedMandatoryIngredients || [], (ingredient, mIdx) => {
                                                                                                return (_openBlock(), _createElementBlock("span", {
                                                                                                    key: `m-${mIdx}`,
                                                                                                    class: "inline-flex items-center bg-blue-100 text-blue-800 px-2 py-0.5 rounded text-xs"
                                                                                                }, " mit " + _toDisplayString(ingredient.name), 1 /* TEXT */));
                                                                                            }), 128 /* KEYED_FRAGMENT */)),
                                                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comp.extraIngredients || [], (ingredient, eIdx) => {
                                                                                                return (_openBlock(), _createElementBlock("span", {
                                                                                                    key: `e-${eIdx}`,
                                                                                                    class: "inline-flex items-center bg-green-100 text-green-800 px-2 py-0.5 rounded text-xs"
                                                                                                }, [
                                                                                                    _createTextVNode(" + " + _toDisplayString(ingredient.name) + " ", 1 /* TEXT */),
                                                                                                    ((ingredient.priceCent || 0) > 0)
                                                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_49, " (+" + _toDisplayString(formatPrice(ingredient.priceCent || 0)) + ") ", 1 /* TEXT */))
                                                                                                        : _createCommentVNode("v-if", true)
                                                                                                ]));
                                                                                            }), 128 /* KEYED_FRAGMENT */)),
                                                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comp.removedIngredients || [], (ingredient, rIdx) => {
                                                                                                return (_openBlock(), _createElementBlock("span", {
                                                                                                    key: `r-${rIdx}`,
                                                                                                    class: "inline-flex items-center bg-red-100 text-red-800 px-2 py-0.5 rounded text-xs"
                                                                                                }, " ohne " + _toDisplayString(ingredient), 1 /* TEXT */));
                                                                                            }), 128 /* KEYED_FRAGMENT */))
                                                                                        ]))
                                                                                        : _createCommentVNode("v-if", true),
                                                                                    (comp.specialInstructions)
                                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString(comp.specialInstructions), 1 /* TEXT */))
                                                                                        : _createCommentVNode("v-if", true)
                                                                                ]));
                                                                            }), 128 /* KEYED_FRAGMENT */))
                                                                        ]))
                                                                        : _createCommentVNode("v-if", true),
                                                                    _createCommentVNode(" Mandatory Ingredients "),
                                                                    (item.itemType !== 'menu' &&
                                                                        item.selectedMandatoryIngredients &&
                                                                        item.selectedMandatoryIngredients.length > 0)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                                                            _createElementVNode("div", _hoisted_52, [
                                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.selectedMandatoryIngredients, (ingredient, idx) => {
                                                                                    return (_openBlock(), _createElementBlock("span", {
                                                                                        key: idx,
                                                                                        class: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800"
                                                                                    }, " mit " + _toDisplayString(ingredient.name), 1 /* TEXT */));
                                                                                }), 128 /* KEYED_FRAGMENT */))
                                                                            ])
                                                                        ]))
                                                                        : _createCommentVNode("v-if", true),
                                                                    _createCommentVNode(" Extras "),
                                                                    (item.itemType !== 'menu' && item.extraIngredients && item.extraIngredients.length > 0)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                                                            _createElementVNode("div", _hoisted_54, [
                                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.extraIngredients, (ingredient, idx) => {
                                                                                    return (_openBlock(), _createElementBlock("span", {
                                                                                        key: idx,
                                                                                        class: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800"
                                                                                    }, " Extra " + _toDisplayString(ingredient.name) + " (+" + _toDisplayString(formatPrice(ingredient.priceCent || 0)) + ") ", 1 /* TEXT */));
                                                                                }), 128 /* KEYED_FRAGMENT */))
                                                                            ])
                                                                        ]))
                                                                        : _createCommentVNode("v-if", true),
                                                                    _createCommentVNode(" Removed Ingredients "),
                                                                    (item.itemType !== 'menu' && item.removedIngredients && item.removedIngredients.length > 0)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                                                            _createElementVNode("div", _hoisted_56, [
                                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.removedIngredients, (ingredient, idx) => {
                                                                                    return (_openBlock(), _createElementBlock("span", {
                                                                                        key: idx,
                                                                                        class: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-red-100 text-red-800"
                                                                                    }, " ohne " + _toDisplayString(ingredient), 1 /* TEXT */));
                                                                                }), 128 /* KEYED_FRAGMENT */))
                                                                            ])
                                                                        ]))
                                                                        : _createCommentVNode("v-if", true),
                                                                    _createCommentVNode(" Special Instructions "),
                                                                    (item.specialInstructions)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                                                            _createElementVNode("p", _hoisted_58, [
                                                                                _cache[15] || (_cache[15] = _createElementVNode("i", { class: "fas fa-comment mr-1" }, null, -1 /* CACHED */)),
                                                                                _createTextVNode(" \"" + _toDisplayString(item.specialInstructions) + "\" ", 1 /* TEXT */)
                                                                            ])
                                                                        ]))
                                                                        : _createCommentVNode("v-if", true)
                                                                ]),
                                                                _createElementVNode("div", _hoisted_59, [
                                                                    _createElementVNode("p", _hoisted_60, _toDisplayString(formatPrice(item.totalPriceCent || 0)), 1 /* TEXT */)
                                                                ])
                                                            ])
                                                        ]));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                ]),
                                                _createCommentVNode(" Pricing Summary "),
                                                _createElementVNode("div", _hoisted_61, [
                                                    _createElementVNode("div", _hoisted_62, [
                                                        _createCommentVNode(" ✅ Original Subtotal (before discount) "),
                                                        _createElementVNode("div", _hoisted_63, [
                                                            _cache[16] || (_cache[16] = _createElementVNode("span", { style: { "color": "#4b5563 !important" } }, "Zwischensumme", -1 /* CACHED */)),
                                                            _createElementVNode("span", _hoisted_64, _toDisplayString(formatPrice(originalSubtotalCent.value)), 1 /* TEXT */)
                                                        ]),
                                                        _createCommentVNode(" ✅ DISCOUNT: Show discounts with codes and details "),
                                                        (order.value.discountAmountCent && order.value.discountAmountCent > 0)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                                                _createElementVNode("div", _hoisted_66, [
                                                                    _createElementVNode("div", _hoisted_67, [
                                                                        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "flex items-center gap-2 mb-1" }, [
                                                                            _createElementVNode("i", { class: "fas fa-tag text-green-600 text-sm" }),
                                                                            _createElementVNode("span", {
                                                                                class: "font-medium text-green-800",
                                                                                style: { "color": "#065f46 !important" }
                                                                            }, " Rabatt angewendet ")
                                                                        ], -1 /* CACHED */)),
                                                                        _createCommentVNode(" Show discount codes if available "),
                                                                        (order.value.discounts && order.value.discounts.length > 0)
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.value.discounts, (discount, idx) => {
                                                                                    return (_openBlock(), _createElementBlock("div", {
                                                                                        key: idx,
                                                                                        class: "text-xs text-green-700",
                                                                                        style: { "color": "#047857 !important" }
                                                                                    }, [
                                                                                        _createElementVNode("span", _hoisted_69, _toDisplayString(discount.code), 1 /* TEXT */),
                                                                                        _createElementVNode("span", _hoisted_70, _toDisplayString(discount.name), 1 /* TEXT */),
                                                                                        _createElementVNode("span", _hoisted_71, "(-" + _toDisplayString(formatPrice(discount.amountCent)) + ")", 1 /* TEXT */)
                                                                                    ]));
                                                                                }), 128 /* KEYED_FRAGMENT */))
                                                                            ]))
                                                                            : _createCommentVNode("v-if", true)
                                                                    ]),
                                                                    _createElementVNode("div", _hoisted_72, [
                                                                        _createElementVNode("span", _hoisted_73, " -" + _toDisplayString(formatPrice(order.value.discountAmountCent)), 1 /* TEXT */)
                                                                    ])
                                                                ])
                                                            ]))
                                                            : _createCommentVNode("v-if", true),
                                                        _createCommentVNode(" ✅ Subtotal after discount "),
                                                        (order.value.discountAmountCent && order.value.discountAmountCent > 0)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                                                _cache[18] || (_cache[18] = _createElementVNode("span", { style: { "color": "#1f2937 !important" } }, "Zwischensumme (nach Rabatt)", -1 /* CACHED */)),
                                                                _createElementVNode("span", _hoisted_75, _toDisplayString(formatPrice(discountedSubtotalCent.value)), 1 /* TEXT */)
                                                            ]))
                                                            : _createCommentVNode("v-if", true),
                                                        _createCommentVNode(" ✅ DEPOSIT: Pfand-Anzeige "),
                                                        (order.value.totalDepositCent && order.value.totalDepositCent > 0)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                                                _cache[19] || (_cache[19] = _createElementVNode("span", {
                                                                    style: { "color": "#4b5563 !important" },
                                                                    class: "flex items-center gap-1"
                                                                }, [
                                                                    _createElementVNode("i", { class: "fas fa-recycle text-green-600 text-xs" }),
                                                                    _createTextVNode(" Pfand (steuerfrei) ")
                                                                ], -1 /* CACHED */)),
                                                                _createElementVNode("span", _hoisted_77, _toDisplayString(formatPrice(order.value.totalDepositCent || 0)), 1 /* TEXT */)
                                                            ]))
                                                            : _createCommentVNode("v-if", true),
                                                        (order.value.deliveryFeeCent > 0)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                                                                _cache[20] || (_cache[20] = _createElementVNode("span", { style: { "color": "#4b5563 !important" } }, "Liefergebühr", -1 /* CACHED */)),
                                                                _createElementVNode("span", _hoisted_79, _toDisplayString(formatPrice(order.value.deliveryFeeCent || 0)), 1 /* TEXT */)
                                                            ]))
                                                            : (_openBlock(), _createElementBlock("div", _hoisted_80, [...(_cache[21] || (_cache[21] = [
                                                                    _createElementVNode("span", { style: { "color": "#4b5563 !important" } }, "Liefergebühr", -1 /* CACHED */),
                                                                    _createElementVNode("span", { class: "font-bold text-green-600" }, "Kostenlos", -1 /* CACHED */)
                                                                ]))])),
                                                        (order.value.serviceFeeCent > 0)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                                                _cache[22] || (_cache[22] = _createElementVNode("span", { style: { "color": "#4b5563 !important" } }, "Servicegebühr", -1 /* CACHED */)),
                                                                _createElementVNode("span", _hoisted_82, _toDisplayString(formatPrice(order.value.serviceFeeCent || 0)), 1 /* TEXT */)
                                                            ]))
                                                            : _createCommentVNode("v-if", true),
                                                        _createElementVNode("div", _hoisted_83, [
                                                            _cache[23] || (_cache[23] = _createElementVNode("span", { style: { "color": "#111827 !important" } }, "Gesamt", -1 /* CACHED */)),
                                                            _createElementVNode("span", _hoisted_84, _toDisplayString(formatPrice(order.value.totalAmountCent || 0)), 1 /* TEXT */)
                                                        ]),
                                                        _createCommentVNode(" Payment Status "),
                                                        _createElementVNode("div", _hoisted_85, [
                                                            _cache[25] || (_cache[25] = _createElementVNode("span", {
                                                                class: "text-sm font-medium",
                                                                style: { "color": "#111827 !important" }
                                                            }, "Zahlungsstatus", -1 /* CACHED */)),
                                                            _createElementVNode("span", {
                                                                class: _normalizeClass([getPaymentStatusClass(order.value.payment?.status), "inline-flex items-center px-3 py-1 rounded-full text-xs font-medium"])
                                                            }, [
                                                                (order.value.payment?.status === 'paid')
                                                                    ? (_openBlock(), _createElementBlock("svg", _hoisted_86, [...(_cache[24] || (_cache[24] = [
                                                                            _createElementVNode("path", {
                                                                                "fill-rule": "evenodd",
                                                                                d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                                                                                "clip-rule": "evenodd"
                                                                            }, null, -1 /* CACHED */)
                                                                        ]))]))
                                                                    : _createCommentVNode("v-if", true),
                                                                _createTextVNode(" " + _toDisplayString(getPaymentStatusText(order.value.payment?.status)), 1 /* TEXT */)
                                                            ], 2 /* CLASS */)
                                                        ]),
                                                        _createCommentVNode(" Payment Method "),
                                                        (order.value.payment?.method)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                                                                _cache[26] || (_cache[26] = _createElementVNode("span", { style: { "color": "#4b5563 !important" } }, "Zahlungsart", -1 /* CACHED */)),
                                                                _createElementVNode("span", _hoisted_88, _toDisplayString(getPaymentMethodText(order.value.payment.method)), 1 /* TEXT */)
                                                            ]))
                                                            : _createCommentVNode("v-if", true)
                                                    ])
                                                ])
                                            ]),
                                            _createCommentVNode(" Action Buttons "),
                                            _createElementVNode("div", _hoisted_89, [
                                                _createElementVNode("div", _hoisted_90, [
                                                    (canCancelOrder.value)
                                                        ? (_openBlock(), _createElementBlock("button", {
                                                            key: 0,
                                                            onClick: cancelOrder,
                                                            disabled: cancelling.value,
                                                            class: "w-full px-4 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50 transition-colors font-medium"
                                                        }, [
                                                            _cache[28] || (_cache[28] = _createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1 /* CACHED */)),
                                                            _createTextVNode(" " + _toDisplayString(cancelling.value ? "Wird storniert..." : "Bestellung stornieren"), 1 /* TEXT */)
                                                        ], 8 /* PROPS */, _hoisted_91))
                                                        : _createCommentVNode("v-if", true),
                                                    _createVNode(_component_router_link, {
                                                        to: "/speisekarte",
                                                        class: "block w-full px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-center transition-colors font-medium"
                                                    }, {
                                                        default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                                                _createElementVNode("i", { class: "fas fa-utensils mr-2" }, null, -1 /* CACHED */),
                                                                _createTextVNode(" Neue Bestellung ", -1 /* CACHED */)
                                                            ]))]),
                                                        _: 1 /* STABLE */
                                                    }),
                                                    _createElementVNode("button", {
                                                        onClick: refreshStatus,
                                                        disabled: loading.value,
                                                        class: "w-full px-4 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 disabled:opacity-50 transition-colors font-medium"
                                                    }, [
                                                        _createElementVNode("i", {
                                                            class: _normalizeClass(["fas fa-sync-alt mr-2", { 'animate-spin': loading.value }])
                                                        }, null, 2 /* CLASS */),
                                                        _cache[30] || (_cache[30] = _createTextVNode(" Status aktualisieren ", -1 /* CACHED */))
                                                    ], 8 /* PROPS */, _hoisted_92)
                                                ])
                                            ])
                                        ])
                                    ])
                                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                : _createCommentVNode("v-if", true)
                ])
            ]));
        };
    }
});
